module.exports = __webpack_public_path__ + "static/media/history-of-actions.37742b52.png";